<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Categories</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="category.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6" v-if="categories && categories.length > 0">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="category.category_id">
                                <option v-bind:value="category.id" v-for="category in categories">{{category.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import CategoryRepo from '../../repos/CategoryRepo'
import _ from 'lodash'

export default {
  name: 'categories-edit',
  components: {},
  data() {
        return {
            repo: new CategoryRepo(this.$auth),
            loading: false,
            categories: [],
            category: {},
        }
  },
  created(){
    this.getCategory(this.$route.params.id);
  },
  methods: {
    getCategory(id){
        this.repo.show(id).then(response => {
            this.category = response.data.data;
        });
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;                                
                
                this.repo.update(this.category.id, this.category).then(function (response) {
                    
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/categories');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/categories/Edit.vue